export const GET_TEAM = 'GET_TEAM';
export const GET_TEAM_SUCCESS = 'GET_TEAM_SUCCESS';
export const GET_TEAM_FAILED = 'GET_TEAM_FAILED';

export const CREATE_TEAM_MEMBER = 'CREATE_TEAM_MEMBER';
export const CREATE_TEAM_MEMBER_SUCCESS = 'CREATE_TEAM_MEMBER_SUCCESS';
export const CREATE_TEAM_MEMBER_FAILED = 'CREATE_TEAM_MEMBER_FAILED';
export const UPDATE_TEAM_MEMBER = 'UPDATE_TEAM_MEMBER';
export const UPDATE_TEAM_MEMBER_SUCCESS = 'UPDATE_TEAM_MEMBER_SUCCESS';
export const UPDATE_TEAM_MEMBER_FAILED = 'UPDATE_TEAM_MEMBER_FAILED';
export const DELETE_TEAM_MEMBER = 'DELETE_TEAM_MEMBER';
export const DELETE_TEAM_MEMBER_SUCCESS = 'DELETE_TEAM_MEMBER_SUCCESS';
export const DELETE_TEAM_MEMBER_FAILED = 'DELETE_TEAM_MEMBER_FAILED';

export const UPDATE_TEAM_MEMBER_AGENDA = 'UPDATE_TEAM_MEMBER_AGENDA';
export const UPDATE_TEAM_MEMBER_AGENDA_SUCCESS = 'UPDATE_TEAM_MEMBER_AGENDA_SUCCESS';
export const UPDATE_TEAM_MEMBER_AGENDA_FAILED = 'UPDATE_TEAM_MEMBER_AGENDA_FAILED';
